import { render, staticRenderFns } from "./SelectColumn.vue?vue&type=template&id=d8ce65e0&scoped=true&"
import script from "./SelectColumn.vue?vue&type=script&lang=js&"
export * from "./SelectColumn.vue?vue&type=script&lang=js&"
import style0 from "./SelectColumn.vue?vue&type=style&index=0&id=d8ce65e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ce65e0",
  null
  
)

export default component.exports